import * as React from "react";
import { DefaultButton, PrimaryButton, FontSizes, Stack, TextField, Checkbox } from "@fluentui/react";
import { generateClient } from "aws-amplify/api";
import { createSendFromNumber } from "../graphql/mutations";

export default function (props) {
  const [number, setNumber] = React.useState("");
  const [inputInvalid, setInputInvalid] = React.useState(false);

  const client = React.useMemo(() => {
    return generateClient();
  }, []);

  const submit = async () => {
    if (!number.match(/(^04\d{8}$)|(^[A-Za-z\- \&\!]{1,13}$)/)) {
      setInputInvalid(true);
      return;
    }
    let modelFields = {
      number,
    };

    try {
      Object.entries(modelFields).forEach(([key, value]) => {
        if (typeof value === "string" && value === "") {
          modelFields[key] = null;
        }
      });
      const newNumber = await client.graphql({
        query: createSendFromNumber,
        variables: { input: modelFields },
      });
      if (props.onSuccess) {
        props.onSuccess(newNumber);
      }
    } catch (err) {
      console.error(err);
      if (props.onError) {
        props.onError(modelFields, err.message);
      }
    }
  };

  return (
    <div className={props.className} style={{ minWidth: 400 }}>
      <div style={{ fontSize: FontSizes.size24, marginBottom: 20 }}>Add Azure Tenant</div>
      <Stack tokens={{ childrenGap: 10 }}>
        <TextField
          label="Alphanumeric Number"
          value={number}
          onChange={(e, v) => setNumber(v)}
          errorMessage={() => {
            return inputInvalid ? 'Must be "04[0-9]{8}" or "[A-Za-z\\-\\&\\! ]{1,13}"' : null;
          }}
        />
        <Stack horizontal={true} horizontalAlign="center" tokens={{ childrenGap: 10, padding: 20 }}>
          <DefaultButton text="Cancel" onClick={props.onCancel} />
          <PrimaryButton text="Submit" onClick={submit} />
        </Stack>
      </Stack>
    </div>
  );
}
